import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useResetPasswordMutation } from '../State/Api/LoginApiSlice';

function ChangePassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const [resetPassword] = useResetPasswordMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
      EmailID: email || '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm your password'),
    }),
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append('password', values.password);
        formData.append('EmailID', values.EmailID);
        await resetPassword(formData).unwrap();
        navigate('/SignIn');
      } catch (error) {
      
      }
    },
    enableReinitialize: true,
  });

  return (
    <>
      <section style={{ width: '100%', height: '100%', display: 'flex', position: 'relative' }}>
        <div className="div-totLg0piuG">
          <form onSubmit={formik.handleSubmit} className="form-ym5zR5QPwa rounded-4">
            <div className="d-flex flex-column align-items-center justify-content-center mb-4">
              <h4 className="fw-bold mb-4">Change Password</h4>
              <span>Enter your new password to reset your account.</span>
            </div>

            <hr className="mb-4" />

            {/* New Password */}
            <div className="div-sxjsnjij9 mb-3 position-relative">
              <label className="form-label fw-semibold" style={{ fontSize: '14px' }}>
                New Password
              </label>
              <input
                name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                className="form-control"
                style={{ width: '100%', height: '2.5rem' }}
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.password && formik.errors.password && (
                <div className="text-danger">{formik.errors.password}</div>
              )}
              <div className="position-absolute" style={{ top: '38px', right: '4px' }}>
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="d-flex align-items-center justify-content-center border-0 bg-transparent"
                >
                  <i className="material-icons" style={{ fontSize: '1.5rem', color: '#ababab' }}>
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </i>
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="div-sxjsnjij9 mb-3 position-relative">
              <label className="form-label fw-semibold" style={{ fontSize: '14px' }}>
                Confirm New Password
              </label>
              <input
                name="confirmPassword"
                type={showConfirm ? 'text' : 'password'}
                placeholder="Confirm Password"
                className="form-control"
                style={{ width: '100%', height: '2.5rem' }}
                value={formik.values.confirmPassword}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.confirmPassword && formik.errors.confirmPassword && (
                <div className="text-danger">{formik.errors.confirmPassword}</div>
              )}
              <div className="position-absolute" style={{ top: '38px', right: '4px' }}>
                <button
                  type="button"
                  onClick={() => setShowConfirm(!showConfirm)}
                  className="d-flex align-items-center justify-content-center border-0 bg-transparent"
                >
                  <i className="material-icons" style={{ fontSize: '1.5rem', color: '#ababab' }}>
                    {showConfirm ? 'visibility_off' : 'visibility'}
                  </i>
                </button>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={formik.isSubmitting}
              className="border-0 rounded-2 d-flex align-items-center justify-content-center"
              style={{
                width: '100%',
                background: '#367588',
                color: '#fff',
                padding: '.5rem .5rem',
                opacity: formik.isSubmitting ? 0.7 : 1,
                cursor: formik.isSubmitting ? 'not-allowed' : 'pointer',
              }}
            >
              {formik.isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Resetting...
                </>
              ) : (
                'Confirm'
              )}
            </button>
          </form>
        </div>

        <div className="img-V6fpDDVfc2">
          <img src="/Images/BG_SignIn.png" alt="" />
        </div>
      </section>
    </>
  );
}

export default ChangePassword;
